import {
  get,
  post,
  postBlob,
  postWithOutQS,
  getBlob,
  patch
} from './http'

//上传
export const uploadImg = p => postWithOutQS('/api/business/upload/img', p); //

export const login = p => post('/api/business/auth/login', p); //登录
export const logout = p => post('/api/business/auth/logout', p); //退出登录
export const getMe = p => get('/api/business/auth/info', p); //获取个人信息
export const authService = p => get('/api/business/auth/service', p); //获取代理商客服信息

//首页统计
export const dashboardMealReport = p => get('/api/business/dashboard/meal_report', p); //
export const dashboardScanReport = p => get('/api/business/dashboard/scan_report', p); //
export const dashboardShopReport = p => get('/api/business/dashboard/shop_report', p); //
export const dashboardShopCase = p => get('/api/business/dashboard/shop_case', p); //
export const dashboardScanCase = p => get('/api/business/dashboard/scan_case', p); //
export const dashboardOrderCase = p => get('/api/business/dashboard/order_case', p); //
export const  dashboardSysInfo = p => get('/api/business/dashboard/sys_info', p); //
export const  dashboardPostOffice = p => get('/api/business/dashboard/post_office', p); //
export const dashboardEvaluationReport = p => get('/api/business/dashboard/evaluation_report', p); //
//新版
export const dashboardUserReport = p => get('/api/business/dashboard/user_report', p); //
export const dashboardMonthReport = p => get('/api/business/dashboard/month_report', p); //
export const dashboardRecentReport = p => get('/api/business/dashboard/recent_report', p); // 

//公告
export const noticeDatagrid = p => get('/api/business/notice/datagrid', p); //
export const noticeDetail = p => get('/api/business/notice/detail', p); //
export const noticeAdd = p => post('/api/business/notice/add', p); //
export const noticeEdit = p => post('/api/business/notice/edit', p); //
export const noticeRemove = p => post('/api/business/notice/remove', p); //
export const noticeStatus = p => post('/api/business/notice/status', p); //

//幻灯片
export const slideDatagrid = p => get('/api/business/slide/datagrid', p); //
export const slideDetail = p => get('/api/business/slide/detail', p); //
export const slideAdd = p => post('/api/business/slide/add', p); //
export const slideEdit = p => post('/api/business/slide/edit', p); //
export const slideRemove = p => post('/api/business/slide/remove', p); //
export const slideStatus = p => post('/api/business/slide/status', p); //

export const mealDatalist = p => get('/api/business/meal/datalist', p); //就餐时段-列表
export const mealDatagrid = p => get('/api/business/meal/datagrid', p); //就餐时段-列表
export const mealAdd = p => post('/api/business/meal/add', p); //就餐时段-新增
export const mealEdit = p => post('/api/business/meal/edit', p); //就餐时段-修改
export const mealRemove = p => post('/api/business/meal/remove', p); //就餐时段-删除

export const officeDatagrid = p => get('/api/business/office/datagrid', p); //部门-列表
export const officeDatalist = p => get('/api/business/office/datalist', p); //部门-列表
export const officeAdd = p => post('/api/business/office/add', p); //部门-新增
export const officeEdit = p => post('/api/business/office/edit', p); //部门-修改
export const officeRemove = p => post('/api/business/office/remove', p); //部门-删除
export const officeMaxRank = p => get('/api/business/office/max_rank', p); //部门-最在排序值

export const postDatagrid = p => get('/api/business/post/datagrid', p); //职务-列表
export const postDatalist = p => get('/api/business/post/datalist', p); //职务-列表
export const postAdd = p => post('/api/business/post/add', p); //职务-新增
export const postEdit = p => post('/api/business/post/edit', p); //职务-修改
export const postRemove = p => post('/api/business/post/remove', p); //职务-删除
export const postMaxRank = p => get('/api/business/post/max_rank', p); //部门-最在排序值

export const whitelistDatagrid = p => get('/api/business/whitelist/datagrid', p); //免审名单-列表
export const whitelistAdd = p => post('/api/business/whitelist/add', p); //免审名单-新增
export const whitelistEdit = p => post('/api/business/whitelist/edit', p); //免审名单-修改
export const whitelistRemove = p => post('/api/business/whitelist/remove', p); //免审名单-删除
export const whitelistExcelTemplate = p => postBlob('/api/business/whitelist/excel_template', p); //EXCEL模板
export const whitelistExcelImport = p => postWithOutQS('/api/business/whitelist/excel_import', p); //导入

//申请记录
export const userApplyDatagrid = p => get('/api/business/user_apply/datagrid', p); //列表
export const userApplyPass = p => post('/api/business/user_apply/pass', p); //通过
export const userApplyRefuse = p => post('/api/business/user_apply/refuse', p); //不通过
export const userApplyTodoCount = p => get('/api/business/user_apply/todo_count', p); //
//人员信息
export const subUserDatagrid = p => get('/api/business/sub_user/datagrid', p); //人员信息列表
export const subUserDetail = p => get('/api/business/sub_user/detail', p); //详情
export const subUserEdit = p => post('/api/business/sub_user/edit', p); //编辑
export const subUserRemove = p => post('/api/business/sub_user/remove', p); //编辑
export const subUserZipTemplate = p => get('/api/business/sub_user/zip_template', p); //批量上传头像模板
export const subUserZipUpload= p => postWithOutQS('/api/business/sub_user/zip_upload', p); //
export const subUserZipUpdate= p => post('/api/business/sub_user/zip_update', p); //
export const subUserExcelTemplate = p => postBlob('/api/business/sub_user/excel_template', p); //批量修改模板
export const subUserExcelImport = p => postWithOutQS('/api/business/sub_user/excel_import', p); //导入
export const subUserExcelExport = p => postBlob('/api/business/sub_user/excel_export', p); //导出

//菜品分类
export const menuTypeDatalist = p => get('/api/business/menu_type/datalist', p); //分类-列表
export const menuTypeAdd = p => post('/api/business/menu_type/add', p); //分类-新增
export const menuTypeEdit = p => post('/api/business/menu_type/edit', p); //分类-修改
export const menuTypeRemove = p => post('/api/business/menu_type/remove', p); //分类-删除

//菜品
export const menuDatagrid = p => get('/api/business/menu/datagrid', p); //
export const menuDatalist = p => get('/api/business/menu/datalist', p); //
export const menuDatagridForDaily = p => get('/api/business/menu/datagrid_for_daily', p); //
export const menuAdd = p => post('/api/business/menu/add', p); //
export const menuDetail = p => get('/api/business/menu/detail', p); //
export const menuEdit = p => post('/api/business/menu/edit', p); //
export const menuRemove = p => post('/api/business/menu/remove', p); //
export const menuExcelTemplate = p => postBlob('/api/business/menu/excel_template', p); //EXCEL模板
export const menuExcelImport = p => postWithOutQS('/api/business/menu/excel_import', p); //导入


//原料分类
export const batchingTypeDatalist = p => get('/api/business/batching_type/datalist', p); //分类-列表
export const batchingTypeAdd = p => post('/api/business/batching_type/add', p); //分类-新增
export const batchingTypeEdit = p => post('/api/business/batching_type/edit', p); //分类-修改
export const batchingTypeRemove = p => post('/api/business/batching_type/remove', p); //分类-删除

//原料
export const batchingDatagrid = p => get('/api/business/batching/datagrid', p); //
export const batchingDatalist = p => get('/api/business/batching/datalist', p); //
export const batchingReport = p => get('/api/business/batching/report', p); //
// export const batchingDatagridForDaily = p => get('/api/business/batching/datagrid_for_daily', p); //
export const batchingAdd = p => post('/api/business/batching/add', p); //
export const batchingDetail = p => get('/api/business/batching/detail', p); //
export const batchingEdit = p => post('/api/business/batching/edit', p); //
export const batchingRemove = p => post('/api/business/batching/remove', p); //
// export const batchingExcelTemplate = p => postBlob('/api/business/batching/excel_template', p); //EXCEL模板
// export const batchingExcelImport = p => postWithOutQS('/api/business/batching/excel_import', p); //导入


//每日菜谱
export const dailyMenuDatagrid = p => get('/api/business/daily_menu/datagrid', p); //
export const dailyMenuDatalist = p => get('/api/business/daily_menu/datalist', p); //
export const dailyMenuMultiAdd = p => post('/api/business/daily_menu/multi_add', p); //
export const dailyMenuAdd = p => post('/api/business/daily_menu/add', p); //
export const dailyMenuRemove = p => post('/api/business/daily_menu/remove', p); //
export const dailyMenuStock = p => post('/api/business/daily_menu/stock', p); //


export const suspensionDatagrid = p => get('/api/business/suspension/datagrid', p); //停/开餐日期
export const suspensionAdd = p => post('/api/business/suspension/add', p); //添加停/开餐日期
export const suspensionRemove = p => post('/api/business/suspension/remove', p); //删除

export const weekPlanDetail = p => get('/api/business/week_plan/detail', p); //周计划
export const weekPlanEdit = p => post('/api/business/week_plan/edit', p); //周计划



export const canteenConfigDetail = p => get('/api/business/canteen_config/detail', p); //配置
export const canteenConfigEdit = p => post('/api/business/canteen_config/edit', p); //修改配置
export const canteenConfigCustom  = p => post('/api/business/canteen_config/custom', p); //修改配置
export const canteenConfigRemoveMenuImg = p => post('/api/business/canteen_config/remove_menu_img', p); //修改配置

//钱包
export const walletDatagrid = p => get('/api/business/wallet/datagrid', p); //
export const walletRecharge = p => post('/api/business/wallet/recharge', p); //
export const walletMultiRecharge = p => post('/api/business/wallet/multi_recharge', p); //
export const walletAdjust = p => post('/api/business/wallet/adjust', p); //
export const walletMultiAdjust = p => post('/api/business/wallet/multi_adjust', p); //
export const walletExcelTemplate = p => postBlob('/api/business/wallet/excel_template', p); //
export const walletExcelImport = p => postWithOutQS('/api/business/wallet/excel_import', p); //
export const walletUpdateByExcel = p => post('/api/business/wallet/update_by_excel', p); //
export const walletExcelExport = p => postBlob('/api/business/wallet/excel_export', p); //
//钱包明细
export const billDatagrid = p => get('/api/business/bill/datagrid', p); //
export const billExcelExport = p => postBlob('/api/business/bill/excel_export', p); //

//报餐明细
export const orderDatagrid = p => get('/api/business/order/datagrid', p); //
export const orderCancel = p => post('/api/business/order/cancel', p); //
export const orderUserStatistic = p => get('/api/business/order/user_statistic', p); //
export const orderStatistic = p => get('/api/business/order/statistic', p); //
export const orderMealStatistic = p => get('/api/business/order/meal_statistic', p); //
export const orderMenuStatistic = p => get('/api/business/order/menu_statistic', p); //
export const orderExcelExport = p => postBlob('/api/business/order/excel_export', p); //导出

//现场点餐
export const outerOrderDatagrid = p => get('/api/business/outer_order/datagrid', p); //
export const outerOrderExcelExport = p => postBlob('/api/business/outer_order/excel_export', p); //

export const orderEvaluationDatagrid = p => get('/api/business/order_evaluation/datagrid', p); //
export const orderEvaluationExcelExport = p => postBlob('/api/business/order_evaluation/excel_export', p); //
//审核员
export const auditorDatalist = p => get('/api/business/auditor/datalist', p); //
export const auditorCount = p => get('/api/business/auditor/count', p); //
export const auditorAdd = p => post('/api/business/auditor/add', p); //
export const auditorEdit = p => post('/api/business/auditor/edit', p); //
export const auditorStatus = p => post('/api/business/auditor/status', p); //
export const auditorRemove = p => post('/api/business/auditor/remove', p); //

//商城 -- 商品分类
export const goodsTypeDatalist = p => get('/api/business/goods_type/datalist', p); //
export const goodsTypeAdd = p => post('/api/business/goods_type/add', p); //
export const goodsTypeEdit = p => post('/api/business/goods_type/edit', p); //
export const goodsTypeRemove = p => post('/api/business/goods_type/remove', p); //
//商城 -- 商品
export const goodsDatagrid = p => get('/api/business/goods/datagrid', p); //
export const goodsAdd = p => post('/api/business/goods/add', p); //
export const goodsDetail = p => get('/api/business/goods/detail', p); //
export const goodsEdit = p => post('/api/business/goods/edit', p); //
export const goodsRemove = p => post('/api/business/goods/remove', p); //
export const goodsSalesStatistic = p => get('/api/business/goods/sales_statistic', p); //

//商城订单
export const goodsOrderDatagrid = p => get('/api/business/goods_order/datagrid', p); //
export const goodsOrderDeliver = p => post('/api/business/goods_order/deliver', p); //
export const goodsOrderCancel = p => post('/api/business/goods_order/cancel', p); //
export const goodsOrderAddress = p => get('/api/business/goods_order/address', p); //
export const goodsOrderExcelExport = p => postBlob('/api/business/goods_order/excel_export', p); //

//问卷
export const questionnaireDatagrid = p => get('/api/business/questionnaire/datagrid', p); //
export const questionnaireAdd = p => post('/api/business/questionnaire/add', p); //
export const questionnaireEdit = p => post('/api/business/questionnaire/edit', p); //
export const questionnaireStatistic = p => get('/api/business/questionnaire/statistic', p); //
export const questionnaireCopy = p => post('/api/business/questionnaire/copy', p); //
export const questionnaireRemove = p => post('/api/business/questionnaire/remove', p); //
export const questionnairePublish = p => post('/api/business/questionnaire/publish', p); //


export const questionnaireTopicDatalist = p => get('/api/business/questionnaire_topic/datalist', p); //
export const questionnaireTopicAdd = p => post('/api/business/questionnaire_topic/add', p); //
export const questionnaireTopicDetail = p => get('/api/business/questionnaire_topic/detail', p); //
export const questionnaireTopicEdit = p => post('/api/business/questionnaire_topic/edit', p); //
//消费二维码 
export const consumeQrcodeDatagrid = p => get('/api/business/consume_qrcode/datagrid', p); //
export const consumeQrcodeAdd = p => post('/api/business/consume_qrcode/add', p); //
export const consumeQrcodeEdit = p => post('/api/business/consume_qrcode/edit', p); //
export const consumeQrcodeRemove = p => post('/api/business/consume_qrcode/remove', p); //
export const consumeQrcodeIsValid = p => post('/api/business/consume_qrcode/is_valid', p); //

//关键词
export const antistopDatagrid = p => get('/api/business/antistop/datagrid', p); //
export const antistopAdd = p => post('/api/business/antistop/add', p); //
export const antistopEdit = p => post('/api/business/antistop/edit', p); //
export const antistopRemove = p => post('/api/business/antistop/remove', p); //

//打印机
export const printerDatalist = p => get('/api/business/printer/datalist', p); //

//子管理员
export const staffDatagrid = p => get('/api/business/staff/datagrid', p); //
export const staffAdd = p => post('/api/business/staff/add', p); //
export const staffDetail = p => get('/api/business/staff/detail', p); //
export const staffEdit = p => post('/api/business/staff/edit', p); //
export const staffIsValid = p => post('/api/business/staff/is_valid', p); //
export const staffRemove = p => post('/api/business/staff/remove', p); //
export const staffUsername = p => get('/api/business/staff/username', p); //
export const staffResources = p => get('/api/business/staff/resources', p); //

export const canteenDetail = p => get('/api/business/canteen/detail', p); // 
export const canteenEdit = p => post('/api/business/canteen/edit', p); // 

//经营报表
export const walletReport = p => get('/api/business/wallet_report/index', p); // 
export const walletReportExport = p => get('/api/business/wallet_report/export', p); // 

export const billReportConsume = p => get('/api/business/bill_report/consume', p); // 
export const billReportExport = p => postBlob('/api/business/bill_report/export', p); // 
export const canteenReport = p => get('/api/business/canteen_report/index', p); // 
export const mealReport = p => get('/api/business/meal_report/index', p); // 
export const mealReportExport = p => postBlob('/api/business/meal_report/export', p); // 

export const absentMealReport = p => get('/api/business/meal_report/absent', p); // 
export const absentMealReportExport = p => postBlob('/api/business/meal_report/absent_export', p); // 
export const mealReportDiscount = p => get('/api/business/meal_report/discount', p); // 

export const payConfigDetail = p => get('/api/business/pay_config/detail', p); // 
export const payConfigEdit = p => post('/api/business/pay_config/edit', p); // 
export const payConfigPemUpload = p => postWithOutQS('/api/business/pay_config/pem_upload', p); // 

export const qrcodeConsumeQrcode = p => post('/api/business/qrcode/consume_qrcode', p); // 
export const qrcodeOuterOrder = p => post('/api/business/qrcode/outer_order', p); // 

//通用
export const getBase64Img = p => get('/api/img/base64', p); //获取base64图片


/******************************* 旧数据 ************************************/

//给首页幻灯片跟菜谱图片上传模块使用的上传图片的url
export const swiperUploadApi = `/home/ad/upload`;//首页幻灯片上传
export const menuUploadApi = `/home/menu/upload`;//菜谱图片上传


//通用
//export const getBase64Img = p => get('/home/img/base64', p); //获取base64图片
export const getAllAuth = p => get('/api/business/auth/permissions', p); //获取所有权限
export const getAudit = p => post('/home/audit/getAudit', p); //根据传输审核类型，返回是否有设置改类型的接口  {type:1(账户充值)/2(取消退餐)/3(小票打印))}
export const getOnline = p => get('/home/index/online', p); //上线时间接口
export const optionIsOpen = p => post('/home/external/isOpen', p); //检查某个选项是否开启
export const moduleStayTime = p => get('/home/external/recordUsedFunction', p); //记录模块停留时长
export const isRemind = () => post('/home/index/remind'); //是否需要即将过期的提醒-返回为空则不需要提醒
export const checkModulePower = () => get('/home/auth/checkModulePower'); //验证某个模块是否开启



export const mealtimeListWithout = p => get('/home/index/meal/list', p); //就餐时段-列表(不用权限的)
export const officesWithout = p => get('/home/index/office/list', p); //部门-列表(不用权限的)
export const postsWithout = p => get('/home/index/post/list', p); //职务-列表(不用权限的)
export const sensorsAnalytics = (id, p) => post(`/home/analytics/sensorsAnalyticsInst/${id}`, p); //埋点
export const userLog = (id, p) => post(`/home/huser/userLog/${id}`, p); //记录所有导出功能的搜索条件


//登录
export const getLoginCode = p => post('/home/external/getLoginCode', p); //获取登录验证码
export const getWebCode = p => post('/home/external/getWebCode', p); //获取短信验证码
export const resetInstPass = p => post('/home/external/resetInstPass', p); //修改密码
export const getCaptchaImage = p => get('/api/captcha/index', p); //获取验证码图片

export const easyLogin = p => post('/home/auth/easyLogin', p); //免密登录
export const loginStatus = p => post('/home/auth/status', p); //对应C端用户状态
export const getAllUser = p => get('/home/auth/getAllUser', p); //获取用户所有账户
export const changeLogin = p => post('/home/auth/changeLogin', p); //免密切换账号


//首页
//export const getMe = p => get('/api/business/auth/info', p); //获取个人信息
export const getInstInfo = p => get('/home/infomanage/centrum/getInstInfo', p); //获取食堂单位信息
//首页数据看板
export const getMealReport = p => post('/home/dashboard/mealReport', p); //获取报餐营收
export const getScanCode = p => post('/home/dashboard/scanCode', p); //获取扫码营收
export const getShopIncome = p => post('/home/dashboard/shopIncome', p); //获取小卖部营收

export const getPostOffice = p => post('/home/dashboard/postOffice', p); //获取部门/职务柱状图
export const getGoodPraise = p => post('/home/dashboard/goodPraise', p); //获取好评柱状图
export const getScanCase = p => post('/home/dashboard/scanCase', p); //获取扫码情况柱状图
export const getUseDinnerCase = p => post('/home/dashboard/useDinnerCase', p); //获取系统用餐情况
export const getSysInfo = () => post('/home/dashboard/sysInfo'); //获取系统使用情况
export const getShopCase = p => post('/home/dashboard/shopCase', p); //获取小卖部情况



// 经营报表
export const getInstReport = p => post('/home/report/getInstReport', p); //获取食堂经营报告
export const getExpenseReport = p => post('/home/report/getExpenseReport', p); //获取用户消费报告(带分页的用于页面展示的接口)
export const exportExpenseReport = p => postBlob('/home/report/exportExpenseReport', p); //获取用户消费报告(不带分页的用于导出的接口)
export const getPresentationReport = p => post('/home/report/getPresentationReport', p); //获取用户账户报告(带分页的用于页面展示的接口)
export const exportPresentationReport = p => post('/home/report/exportPresentationReport', p); //获取用户账户报告(不带分页的用于导出的接口)
export const mealTimeByOffice = p => post('/home/report/mealTimeByOffice', p); //获取各时段就餐情况
export const exportMealTimeByOffice = p => postBlob('/home/report/exportMealTimeByOffice', p); //导出各时段就餐情况
export const systemByUser = p => post('/home/report/systemByUser', p); //获取未实际就餐统计
export const exportSystemByUser = p => postBlob('/home/report/exportSystemByUser', p); //导出未实际就餐统计
export const firstDiscountByOffice = p => post('/home/report/firstDiscountByOffice', p); //获取首份优惠情况

//用餐人员管理
export const maxRank = p => get('/home/index/rank', p); //最大排序

export const hofficeIndex = p => get('/home/hoffice/index', p); //部门设置-列表
export const createOffice = p => post('/home/hoffice/create', p); //部门设置-添加部门
export const deleteOffice = (id, p) => post(`/home/hoffice/delete/${id}`, p); //部门设置-删除部门
export const updateOffice = (id, p) => post(`/home/hoffice/update/${id}`, p); //部门设置-编辑部门

export const hpostIndex = p => get('/home/hpost/index', p); //职务设置-列表
export const createPost = p => post('/home/hpost/create', p); //职务设置-添加职务
export const deletePost = (id, p) => post(`/home/hpost/delete/${id}`, p); //职务设置-删除职务
export const updatePost = (id, p) => post(`/home/hpost/update/${id}`, p); //职务设置-编辑职务


export const huserphoIndex = p => get('/home/huserpho/index', p); //免审核名单-列表
export const importWhiteList = p => postWithOutQS('/home/huserpho/importWhiteList', p); //免审核名单-批量添加白名单
export const WhiteListDownloadTemplate = p => postBlob('/home/huserpho/downloadTemplate', p); //免审核名单-白名单模板下载
export const huserphoCreate = p => post('/home/huserpho/create', p); //免审核名单-添加人员
export const huserphoUpdate = (id, p) => post(`/home/huserpho/update/${id}`, p); //免审核名单-编辑人员
export const huserphoDelete = (id, p) => post(`/home/huserpho/delete/${id}`, p); //免审核名单-删除人员
export const batchDeleteByIds = p => post(`/home/huserpho/batchDeleteByIds/`, p); //免审核名单-批量删除所选人员
export const batchDeleteAll = p => post(`/home/huserpho/batchDeleteAll`, p); //免审核名单-批量删除全部人员


export const huserIndex = p => get('/home/huser/index', p); //人员信息管理-列表
export const huserDownloadTemplate = p => getBlob('/home/huser/downloadTemplate', p); //人员信息管理-批量更新模板下载
export const huserUpdateBatch = p => postWithOutQS('/home/huser/updateBatch', p); //人员信息管理-批量更新用户
export const huserDownloadZip = p => get('/home/huser/downloadZip', p); //人员信息管理-批量更新头像模板下载
export const huserUploadUserPhotos = p => postWithOutQS('/home/huser/uploadUserPhotos', p); //人员信息管理-上传批量头像zip文件
export const huserUpdateUserPhotos = p => post('/home/huser/updateUserPhotos', p); //人员信息管理-批量更新用户头像
export const huserDelete = (id, p) => post(`/home/huser/delete/${id}`, p); //人员信息管理-删除用户
export const huserDetail = (id, p) => get(`/home/huser/update/${id}`, p); //人员信息管理-用户详情
export const huserUpdate = (id, p) => post(`/home/huser/update/${id}`, p); //人员信息管理-编辑用户
export const huserUpdatePic = p => postWithOutQS('/home/huser/upload', p); //人员信息管理-上传用户头像
export const happlyIndex = p => get('/home/happly/index', p); //人员信息管理-用户申请表
export const happlyUpdate = (id, p) => post(`/home/happly/update/${id}`, p); //人员信息管理-处理用户申请列表
export const happlyIndexAll = p => get('/home/index/users', p); //人员信息管理-用户列表（包含刚申请的用户）

export const getAddQrcode = () => post(`/home/qrcode/getInstitutionQrcode`); //人员信息管理-添加用餐人员之前要请求的接口
export const getInstitutionCode = () => post(`/home/qrcode/getInstitutionCode`); //人员信息管理-添加用餐人员-获取代理商食堂的加入食堂编码
export const getShareLink = () => get(`/home/qrcode/getShareLink`); //人员信息管理-添加用餐人员-通过微信邀请链接添加(获取链接)

//账户管理
export const accounts = p => post('/home/account/account', p); //账户充值-用户账户列表
export const manyRecharge = p => post('/home/account/manyRecharge', p); //账户充值-批量充值
export const manyAdjustment = p => post('/home/account/manyAdjustment', p); //账户充值-批量调整
export const accountDownloadTemplate = p => getBlob('/home/account/downloadTemplate', p); //账户充值-个性化充值模板下载
export const accountUploadPersonalized = p => postWithOutQS('/home/account/uploadPersonalized', p); //账户充值-上传个性化充值文件
export const updatePersonalized = p => post('/home/account/updatePersonalized', p); //账户充值-更新个性化批量充值
export const singleRecharge = p => post('/home/account/singleRecharge', p); //账户充值-单个充值
export const singleAdjustment = p => post(`/home/account/singleAdjustment`, p); //账户充值-单个调整

export const accountRecordList = p => post('/home/account/recordList', p); //账户收支记录列表

//用餐管理
export const suspension = p => get('/home/suspension/index', p); //不开餐日期-列表
export const suspensionCreate = p => post('/home/suspension/create', p); //不开餐日期-添加
export const suspensionDelete = id => post(`/home/suspension/delete/${id}`); //不开餐日期
export const weekplan = p => get('/home/index/inst/weekplan', p); //不开餐日期
export const suspensionUpdate = p => post('/home/suspension/update', p); //不开餐日期
export const getAheadDay = p => get('/home/index/inst/config', p); //不开餐日期
export const updateAheadDay = p => post('/home/index/maxMeal', p); //不开餐日期-添加


export const orderList = p => get('/home/order/list', p); //报餐明细-列表
//export const orderCancel = (id, p) => post(`/home/order/cancel/${id}`, p); //报餐明细-取消报餐订单
export const getDetailReport = p => get('/home/order/getDetailReport', p); //报餐明细-导出九月份数据
export const getTempOrders = p => post(`/home/order/getTempOrders`, p); //报餐明细-用于有的用户需要导出旧区间数据
export const listOutsiderOrders = p => post(`/home/order/listOutsiderOrders`, p); //报餐明细-获取外部订单列表


export const dailyIndex = p => get('/home/daily/index', p); //每日菜谱-列表
export const dailyCreate = p => post('/home/daily/create', p); //每日菜谱-添加
export const dailyList = p => get('/home/daily/list', p); //每日菜谱-选择菜品页面
export const dailyDelete = (id, p) => post(`/home/daily/delete/${id}`, p); //每日菜谱-删除每日菜谱下的某个菜品
export const dailyUpdate = (id, p) => post(`/home/daily/update/${id}`, p); //每日菜谱-编辑每日菜谱下的某个菜品
export const dailyBatchUpdate = p => post(`/home/daily/multiple`, p); //每日菜谱-批量添加



export const menuTypesList = p => get('/home/index/menutype/list', p); //菜品库-菜品类别列表(用这个)
export const menuTypes = p => get('/home/menutype/index', p); //菜品库-菜品类别列表
export const menuTypeCreate = p => post('/home/menutype/create', p); //菜品库-添加菜品类别
export const menuTypeUpdate = (id, p) => post(`/home/menutype/update/${id}`, p); //菜品库-编辑菜品类别
export const menuTypeDelete = (id, p) => post(`/home/menutype/delete/${id}`, p); //菜品库-删除菜品类别
export const menuIndex = p => get('/home/menu/index', p); //菜品库-菜品列表
export const menuCreate = p => post('/home/menu/create', p); //菜品库-添加菜品
export const menuPicUpload = p => postWithOutQS('/home/menu/upload', p); //菜品库-菜品图片上传
export const menuDetailBak = id => get(`/home/menu/update/${id}`); //菜品库-单个菜品详情
export const menuUpdate = (id, p) => post(`/home/menu/update/${id}`, p); //菜品库-单个菜品编辑
export const menuDelete = id => post(`/home/menu/delete/${id}`); //菜品库-单个菜品删除

export const mealtimeList = p => get('/home/mealtime/index', p); //就餐时段-列表
export const batchMealtimeList = p => get('/home/mealtime/batch', p); //批量报餐时段-列表
export const mealtimeCreate = p => post('/home/mealtime/create', p); //就餐时段-添加
export const mealtimeUpdate = (id, p) => post(`/home/mealtime/update/${id}`, p); //就餐时段-编辑
export const mealtimeBatchUpdate = (id, p) => post(`/home/mealtime/updateBatch/${id}`, p); //就餐时段-编辑
export const mealtimeDelete = (id, p) => post(`/home/mealtime/delete/${id}`, p); //就餐时段-删除


export const getGoodsList = p => get('/home/goods/getGoodsList', p); //小卖部商品管理-列表
export const addGoods = p => post('/home/goods/addGoods', p); //小卖部商品管理-新增商品
export const getEditGoods = id => get(`/home/goods/editGoods/${id}`); //小卖部商品管理-编辑商品页面
export const editGoods = (id, p) => post(`/home/goods/editGoods/${id}`, p); //小卖部商品管理-编辑商品
export const delGoods = id => post(`/home/goods/delGoods/${id}`); //小卖部商品管理-删除商品
export const goodsUpload = p => postWithOutQS(`/home/goods/upload`, p); //小卖部商品管理-上传图片
export const getTypeList = p => get('/home/goods/getTypeList', p); //小卖部商品管理-商品分类列表
export const addType = p => post('/home/goods/addType', p); //小卖部商品管理-新增分类
export const editType = (id, p) => post(`/home/goods/editType/${id}`, p); //小卖部商品管理-编辑分类
export const delType = (id, p) => post(`/home/goods/delType/${id}`, p); //小卖部商品管理-删除分类

export const getGoodsOrder = p => post('/home/goods/getGoodsOrder', p); //小卖部订单管理-查询订单
export const cancelOrder = id => post(`/home/goods/cancelOrder/${id}`); //小卖部订单管理-取消订单
export const updateOrder = id => post(`/home/goods/updateOrder/${id}`); //小卖部订单管理-订单配送
export const getGoodsSales = p => post('/home/goods/getGoodsSales', p); //小卖部订单管理-统计商品销售量

export const getStatisticsDetail = p => get('/home/order/statistics/detail', p); //报餐统计-菜品
export const getStatisticsPerson = p => get('/home/order/statistics', p); //报餐统计-人次
export const getStatisticsUsers = p => get('/home/order/statistics/person', p); //报餐统计-人数

export const getConsumeQrcode = p => get('/home/qrcode/getConsumeQrcode', p); //消费二维码
export const addConsumeQrcode = p => post('/home/qrcode/addConsumeQrcode', p); //消费二维码
export const editConsumeQrcode = (id, p) => post(`/home/qrcode/editConsumeQrcode/${id}`, p); //消费二维码
export const delConsumeQrcode = id => post(`/home/qrcode/delConsumeQrcode/${id}`); //消费二维码
export const swichtQrcode = (id, p) => post(`/home/qrcode/switchQrcode/${id}`, p); //消费二维码

export const getEstimate = p => get('/home/estimate/index', p); //评价管理

export const getAntistop = p => get('/home/antistop/index', p); //关键词管理
export const addAntistop = p => post('/home/antistop/create', p); //关键词管理添加
export const updateAntistop = (id, p) => post(`/home/antistop/update/${id}`, p); //关键词管理修改
export const deleteAntistop = (id, p) => post(`/home/antistop/del/${id}`, p); //关键词管理删除

export const getSceneMealQrcode = p => post('/home/qrcode/getSceneMealQrcode', p); //现场点餐获取点餐码
export const getDeviceList = () => get('/home/qrcode/getPrinters'); //现场点餐-获取飞蛾列表
export const setSceneStatus = p => post('/home/infomanage/centrum/setScene', p); //设置现场点餐二维码开关
export const getSceneStatus = () => post('/home/infomanage/centrum/getScene'); //设置现场点餐二维码开关


//单位信息
export const getInstVersion = p => get('/home/infomanage/centrum/getInstVersion', p); //版本信息-获取使用的版本信息
export const getBuyVersion = p => post('/home/payment/getBuyVersion', p); //版本信息-购买/续费时版本选择页面
export const postAddInstitutionApply = p => post('/home/payment/payInstitutionVersion', p); //版本信息-购买/续费时生成订单
export const calcInstitutionVersion = p => post('/home/payment/calcInstitutionVersion', p); //版本信息-切换时版本选择页面
export const updateInstitutionVersion = p => post('/home/payment/updateInstitutionVersion', p); //版本信息-切换版本更新接口
/*
 *@date: 2021-02-04 10:02:07
*/
export const showProduction = p => post('/home/payment/showProduction', p); //版本信息-获取各版本列表
export const addShopCart = p => post('/home/payment/shopcart/addShopCart', p); //版本信息-添加到意向购买列表
export const showShopCart = p => post('/home/payment/shopcart/showShopCart', p); //版本信息-获取意向购买列表
export const removeShopCart = cart => post(`/home/payment/shopcart/removeShopCart/${cart}`); //版本信息-移除单个意向购买
export const generateOrder = p => post('/home/payment/order/generateOrder', p); //版本信息-从意向购买列表中生成待支付订单
export const payOrder = p => post('/home/payment/order/payOrder', p); //版本信息-选择支付方式
export const quickOrder = p => post('/home/payment/order/quickOrder', p); //版本信息-快速下单
export const getOrder = p => post('/home/payment/order/getOrder', p); //版本信息-订单列表
export const getOrderList = p => post('/home/payment/order/getOrderList', p); //版本信息-订单列表
export const removeOrder = id => post(`/home/payment/order/removeOrder/${id}`); //版本信息-移除待支付订单
export const getApply = id => get(`/home/invoice/apply/${id}`); //获取发票信息
export const updateApply = (id, p) => post(`/home/invoice/apply/${id}`, p); //提交发票信息
export const zeroPay = p => post(`/home/payment/order/zeroPay`, p); //零元购买选项



//系统设置
export const notices = p => get('/home/notice/getNoticeList', p); //公告管理
export const disableNotice = (id, p) => post(`/home/notice/disableNotice/${id}`, p); //公告启用禁用
export const noticePicUpload = p => postWithOutQS('/home/notice/upload', p); //菜品库-菜品图片上传
export const addNotice = p => post('/home/notice/addNotice', p); //公告管理
export const getEditNotice = (id, p) => get(`/home/notice/editNotice/${id}`, p); //公告管理
export const editNotice = (id, p) => post(`/home/notice/editNotice/${id}`, p); //公告管理
export const removeNotice = id => post(`/home/notice/delNotice/${id}`); //公告管理

//幻灯片管理
export const ads = p => get('/home/ad/getAdList', p); //幻灯片管理
export const disableAd = (id, p) => post(`/home/ad/disableAd/${id}`, p); //幻灯片启用禁用
export const addAd = p => post('/home/ad/addAd', p); //公告管理
export const getEditAd = (id, p) => get(`/home/ad/editAd/${id}`, p); //公告管理
export const editAd = (id, p) => post(`/home/ad/editAd/${id}`, p); //公告管理
export const removeAd = id => post(`/home/ad/delAd/${id}`); //公告管理

//菜品图片上传
export const menus = p => get('/home/menu/getMenuList', p); //幻灯片管理
export const getEditMenu = () => get(`/home/menu/editMenu`); //幻灯片启用禁用
export const editMenu = (p) => post(`/home/menu/editMenu`, p); //公告管理
export const removeMenu = () => post(`/home/menu/delMenu`); //公告管理

//单位管理
export const sendSmsCode = p => post(`/home/vercode/getVerificationCode`, p); //公告管理
export const checkSmsCode = p => post(`/home/vercode/checkVerificationCode`, p); //公告管理
export const updateInstMobile = p => post(`/home/infomanage/centrum/updateInstitutionMobile`, p); //公告管理
export const editInstInfo = p => post(`/home/infomanage/centrum/updateInstitutionInfo`, p); //公告管理

//管理员分配
export const instAdmins = p => get(`/home/haccount/index`, p); //公告管理
export const authorities = () => get(`/home/haccount/create`); //公告管理
export const addInstAdmin = p => post(`/home/haccount/create`, p); //公告管理
export const getEditInstAdmin = id => get(`/home/haccount/update/${id}`); //公告管理
export const editInstAdmin = (id, p) => post(`/home/haccount/update/${id}`, p); //公告管理
export const disableInstAdmin = (p) => post(`/home/haccount/disable`, p); //公告管理
export const removeInstAdmin = id => post(`/home/haccount/delete/${id}`); //公告管理
export const instGetName = p => post(`/home/haccount/getName`, p); 

//待报餐管理
export const autoMealRules = p => get(`/home/index/rule/list`, p); //公告管理
export const disableAutoMealRule = (id, p) => post(`/home/index/rule/update/${id}`, p); //公告管理
export const autoMealMenus = p => get(`/home/index/rule/menu`, p); //公告管理
export const autoMealUsers = p => get(`/home/index/rule/user`, p); //公告管理
export const addAutoMealRule = p => post(`/home/menu/multiple`, p); //公告管理
export const removeAutoMealRule = (id) => post(`/home/menu/multiple/del/${id}`); //公告管理

//审核账号管理
export const auditAdmins = p => get(`/home/audit/getAuditList`, p); //公告管理
export const editAuditAdmin = p => post(`/home/audit/editAudit`, p); //公告管理
export const addAuditAdmin = p => post(`/home/audit/addAudit`, p); //公告管理
export const removeAuditAdmin = (id) => post(`/home/audit/delAudit/${id}`); //公告管理

//模式切换
export const getInstProInfo = () => get(`/home/frog/getInstitutionPro`); //公告管理
export const setVoice = (p) => post(`/home/frog/setVoice`, p); //公告管理
export const instConfig = (p) => post(`/home/infomanage/centrum/setInstitution`, p); //公告管理
export const editRemindMoney = (p) => post(`/home/remind/edit`, p); //修改提醒金额
export const getRemindMoney = () => get(`/home/remind/index`); //获取提醒金额 
export const setJumpDetail = (p) => post(`/home/infomanage/centrum/setJumpDetail`, p); //青蛙核销后是否能跳转详情

// 模块管理
export const getModuleList = p => get(`/home/module/index`, p); //模块列表
export const switchModule = p=> post(`/home/module/close`, p); //开启/关闭模块
export const getOptionList = (id, p) => get(`/home/option/index/${id}`, p); //获取模块下的选项列表
export const sendVerificationCode = () => post(`/home/module/message`); //切换版本时发送验证码
export const switchVersionInfo = p => post(`/home/module/switchInfo`, p); //切换版本时获取版本差异
export const switchVersion = p => post(`/home/module/switch`, p); //切换版本
export const switchOption = id => post(`/home/option/switch/${id}`); //切换选项

// 问卷
export const addQuestionnaire = (p) => post(`/home/questionnaire/store`, p); //添加问卷
export const updateQuestionnaire = (id, p) => post(`/home/questionnaire/update/${id}`, p); //修改问卷
export const totalQuestionnaire = (id, p) => get(`/home/questionnaire/show/${id}`, p); //问卷统计
export const getQuestionnaires = p => get(`/home/questionnaire/index`, p); //问卷列表
export const pushQuestionnaire = (id, p) => post(`/home/questionnaire/push/${id}`, p); //发布问卷
export const deleteQuestionnaire = id => post(`/home/questionnaire/delete/${id}`); //删除问卷
export const copyQuestionnaire = id => post(`/home/questionnaire/copy/${id}`); //复制问卷
export const exportQuestionnaire = id => postBlob(`/home/questionnaire/export/${id}`);//导出问卷
export const getQuestions = id => get(`/home/questionnaire/topic/index/${id}`); //问卷下的问题列表
export const addQuestion = (p) => post(`/home/questionnaire/topic/store`, p); //添加问题
export const updateQuestion = (id, p) => post(`/home/questionnaire/topic/update/${id}`, p); //修改问题
export const getQuestion = id => get(`/home/questionnaire/topic/edit/${id}`); //获取所修改的问题详情
export const deleteQuestion = id => post(`/home/questionnaire/topic/delete/${id}`); //删除问题

//版本升降配
export const getModules = (p) => post(`/home/version/info/getModules`, p);//获取在售模块
export const getVersionPacket = (p) => post(`/home/version/info/getVersionPacket`, p);//获取预置版本(包)
export const getInstVersionInfo = (p) => post(`/home/version/info/getInstVersion`, p);//获取当前食堂配置信息
export const getVersionPrice = (p) => post(`/home/version/info/getVersionPrice`, p);//获取变更后的价格
export const getPolicy = (p) => post(`/home/version/info/getPolicy`, p);//获取隐私政策,用户协议等

//小程序授权、代码管理
export const getAuthUrl = (p) => get(`/api/weixin/miniapp_bind/auth_url`, p);
export const getAppInfo = (p) => get(`/api/weixin/app_info/detail`, p);
export const bindCallback = (p) => post(`/api/weixin/miniapp_bind/bind_callback`, p);
export const miniappUnbind = (p) => post(`/api/weixin/miniapp_bind/unbind`, p);
export const miniappCommit = (p) => post(`/api/weixin/miniapp/commit`, p);
export const miniappAudit = (p) => post(`/api/weixin/miniapp/audit`, p);
export const miniappRelease = (p) => post(`/api/weixin/miniapp/release`, p);
export const appProgramUndoAudit = (p) => post(`/api/weixin/app_program/undo_audit`, p);
export const appProgramAuditStatus = (p) => post(`/api/weixin/app_program/audit_status`, p);


//客餐
export const getGuestMeal = (p) => get(`/api/business/guest_meal/datagrid`, p);//客餐列表
export const postGuestMealCreate = (p) => post(`/api/business/guest_meal/create`, p);//新增客餐
export const postGuestMealUpdate = (p) => post(`/api/business/guest_meal/update`, p); //修改客餐
export const postGuestMealDelete = (p) => post(`/api/business/guest_meal/delete`, p); //删除客餐
export const getGuestMealOrder = (p) => get(`/api/business/guest_meal/order/datagrid`, p);//客餐记录
export const getGuestMealOrderStat = (p) => get(`/api/business/guest_meal/order/stat`, p);//客餐统计